import ComponentName from '@Constant/componentName'

const home = [
  {
    component: () => import('../../views/layout/Index.vue'),
    path: '/account',
    redirect: {
      name: ComponentName.home
    },
    children: [
      {
        component: () => import('../../views/account/Index.vue'),
        path: 'info',
        name: ComponentName.account,
        auth: '*',
        meta: {
          title: '账户信息'
        }
      },
      {
        component: () => import('../../views/account/secondary/Index.vue'),
        path: 'subAccount',
        name: ComponentName.subAccount,
        auth: '*',
        meta: {
          title: '子账号管理'
        }
      },
      {
        component: () => import('../../views/account/secondary/AuthInfo.vue'),
        path: 'authInfo',
        name: ComponentName.secondAuthInfo
      }
    ]
  }
]

export default home
